'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeOptions = mergeOptions;

var _lodash = require('lodash.merge');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mergeOptions(obj, src) {
  return (0, _lodash2.default)(obj, src);
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-chartjs/es/helpers/options.js
// module id = 25
// module chunks = 0